import { useState,  useCallback, useRef } from 'react';

export const useProductTour = (productTourDetails, user) => {
  const [showTourInitiation, setShowTourInitiation] = useState(false);
  const [showTourSkipped, setShowTourSkipped] = useState(false);
  const [isTourActive, setIsTourActive] = useState(false);
  const hasTriggeredRef = useRef(false);

  const isWolibaCompany = user?.company_id === 1;
  const tourCompleted = productTourDetails?.product_tour_data?.user_dashboard === false;

  const canShowTour = useCallback(() => {
    if (!isWolibaCompany || tourCompleted) return false;

    const hraCompleted = localStorage.getItem('hra_completed') === 'true';
    if (!hraCompleted) return false;

    const isNewUser = productTourDetails?.is_new_user === true;
    if (isNewUser) {
      const locationDeptCompleted = localStorage.getItem('location_dept_completed') === 'true';
      if (!locationDeptCompleted) return false;
    }

    const reminderDate = localStorage.getItem('product_tour_reminder_date');
    if (reminderDate && new Date() < new Date(reminderDate)) return false;

    return true;
  }, [isWolibaCompany, tourCompleted, productTourDetails?.is_new_user]);

  const showTourInitiationPopup = useCallback(() => {
    if (canShowTour() && !hasTriggeredRef.current) {
      hasTriggeredRef.current = true;
      setShowTourInitiation(true);
    }
  }, [canShowTour]);

  const startTour = useCallback(() => {
    setShowTourInitiation(false);
    setIsTourActive(true);
    localStorage.removeItem('start_product_tour');
  }, []);

  const skipTour = useCallback(() => {
    setShowTourInitiation(false);
    setShowTourSkipped(true);
    const reminderDate = new Date();
    reminderDate.setDate(reminderDate.getDate() + 30);
    localStorage.setItem('product_tour_reminder_date', reminderDate.toISOString());
    localStorage.removeItem('start_product_tour');
  }, []);

  const completeTour = useCallback(() => {
    setIsTourActive(false);
    localStorage.removeItem('product_tour_reminder_date');
    localStorage.removeItem('start_product_tour');
  }, []);

  const closeTourSkippedPopup = useCallback(() => {
    setShowTourSkipped(false);
  }, []);

  return {
    showTourInitiation,
    showTourSkipped,
    isTourActive,
    startTour,
    skipTour,
    completeTour,
    closeTourSkippedPopup,
    showTourInitiationPopup
  };
};
